//@flow
import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Avatar } from 'gestalt';

type Props = {|
  avatarUrl: string,
  creditNameLink?: string,
  name: string,
|};

export default function CreditAvatar({ avatarUrl, creditNameLink, name = '' }: Props) {
  return creditNameLink ? (
    <NavigateLink className="underlineLink" stopPropagation to={creditNameLink}>
      <Avatar name={name} src={avatarUrl} size="sm" />
    </NavigateLink>
  ) : (
    <Avatar name={name} src={avatarUrl} size="sm" />
  );
}
